export default __webpack_public_path__ + "static/media/tickMark.22b25b08.svg";